<template lang="pug">
  v-select(
    :value="value"
    :items="items"
    :label="label"
    :item-text="itemText" 
    :item-value="itemValue"
    :disabled="disabled"
    :return-object="!itemValue"
    :multiple="multiple"
    :rules="rules"
    :hide-details="hideDetails"
    :dense="dense"
    outlined 
    light
    @input="handleSelect"
    :menu-props="menuProps"
  )
</template>

<script>
export default {
  name: "app-select",
  props: {
    value: [String, Number, Object, Array],
    label:  String,
    items: Array,
    disabled: Boolean,
    itemText: String,
    itemValue: String,
    multiple: Boolean,
    rules: [Object, Array], 
    hideDetails: {
      type: Boolean, 
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    menuProps: {
      type: [String, Array, Object]
    }
  },
  methods: {
    handleSelect (event) {
      this.$emit('input', event)
    }
  }
}
</script>

<style>
  .v-select__selections {
    overflow: hidden;
  }
</style>
</style>

<style scoped>

</style>


